import React from "react";

const UserInfo = ({ userInfo }) => {
  return (
    <div className="pb-4 border-bottom mb-4">
      {console.log(userInfo, "userInfo")}
      <h6 className="mb-2">Thông tin người thanh toán</h6>
      <div className="row g-3">
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Tên</h6>
          <p className="fs-16 text-gray-6">{userInfo.fullName}</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Email</h6>
          <p className="fs-16 text-gray-6">
            <a
              href="#"
              className="__cf_email__"
              data-cfemail="ec8f849e8a83dedfd9daac89948d819c8089c28f8381"
              onClick={(e) => e.preventDefault()}
            >
              {userInfo.email}
            </a>
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Điện thoại</h6>
          <p className="fs-16 text-gray-6">+{userInfo.phoneNumber}</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Địa chỉ</h6>
          <p className="fs-16 text-gray-6">{userInfo.address}</p>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
